import types from './types';

export const setMemberships = byId => ({
    type: types.SET_MEMBERSHIPS,
    payload: { byId },
});
